import { Modal, theme, Tooltip } from "antd";
import React from "react";
import ColorButton from "../../common/ColorButton";
import ErrorMessages from "../../common/ErrorMessages";
import {
  PlusCircleFilled,
  EditOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';
import TSTable from "../../common/TSTable";
import { URL_CHEMICAL } from "../../constants/urls";
import { dateToHumanString, toFixed } from "../../frameworks/Util";
import QualityChemicalMeterModal from "./QualityChemicalMeterModal";
import { DELETE } from "../../frameworks/HttpClient";

export default function QualityChemicalMeterList(props) {
  const [ errorMessages, setErrorMessages ] = React.useState(false);
  const [ target, setTarget] = React.useState(null);
  const tableRef = React.useRef(null);

  const {
    token: { colorSuccess, colorError, colorWarning },
  } = theme.useToken();

  const refreshData = async() => {
    if(tableRef.current){
      await tableRef.current.fetchWithoutResetPage();
    }
  }

  const columns = [
    {
      title: "Action",
      dataIndex: "",
      width: 200,
      key: "action",
      align: "center",
      render: (_, record) => 
          <div onClick={(e) => e.stopPropagation()}>
              <Tooltip triger='hover' title="ลบรายการ">
                <ColorButton
                  type="primary"
                  override={colorError}
                  style={{ marginRight: 10 }}
                  icon={<DeleteOutlined />}
                  onClick={() => confirm(record.name, record.id)}
                />
              </Tooltip>
            <Tooltip triger='hover' title="แก้ไขข้อมูล">
              <ColorButton
                type="primary"
                override={colorWarning}
                icon={<EditOutlined />}
                onClick={() => setTarget(record)}
              />
            </Tooltip>
          </div>
    },
    {
      title: "ชื่อมิเตอร์",
      dataIndex: "name",
      key: "name",
      ellipsis: true,
      align: "center",
      searcher : true,
    },
    {
      title: "เลขมิเตอร์ปัจจุบัน",
      dataIndex: "current",
      key: "current",
      align: "center",
      render : (value) => toFixed(value, 2)
    },
    {
      title: "วันที่สร้าง",
      dataIndex: "created",
      key: "created",
      align: "center",
      render : (value) => dateToHumanString(value)
    },
    {
      title: "วันที่แก้ไขล่าสุด",
      dataIndex: "updated",
      key: "updated",
      align: "center",
      render : (value) => dateToHumanString(value)
    }
  ];

  const confirm = (title, value) => {
    Modal.confirm({
      title: `ลบมิเตอร์ - ${title}`,
      icon: <ExclamationCircleOutlined style={{ color : colorError}} />,
      content: 'คุณต้องการลบมิเตอร์หรือไม่ ?',
      okText: 'ใช่',
      cancelText: 'ไม่ใช่',
      maskClosable: true,
      okButtonProps: {style: { backgroundColor : colorError}},
      onOk:async() => {
        await handleDeleteMeter(value)
        refreshData();
      },
      onConfirm: () => refreshData()
    });
  };

  const handleDeleteMeter= async(id) => {
    setErrorMessages(null)
    try {
      await DELETE(`${URL_CHEMICAL.METER}${id}/`)
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }


  return(
   <div>
      <ErrorMessages message={errorMessages}/>

      <ColorButton
        type={'primary'}
        override={colorSuccess}
        style={{ float : 'right', marginBottom : 10}}
        icon={<PlusCircleFilled />} 
        onClick={() => setTarget('add')}>
          {"เพิ่มมิเตอร์"}
      </ColorButton>

      <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_CHEMICAL.METER}
      />

      <QualityChemicalMeterModal
        open={target ? true : false}
        onClose ={() => {
          setTarget(null)
        }}
        onUpdate={() => {
          setTarget(null)
          refreshData();
        }}
        target={target}
      />
   </div> 
  )
}